import Typography from "@portal/components/atoms/v2/typography";
import { useState } from "react";
import { RobotTextResources } from "@portal/assets/text/RobotTextResources";
import { ChevronCircleButton } from "@portal/components/atoms/buttons/chevronCircle/ChevronCircleButton";
import { SelectionBoxComponent } from "../../../components/selectionBox/SelectionBoxComponent";
import { useRobot } from "@portal/app/context/robotProvider";
import { ISustainabilityProps } from "../../common/types";
import { GetOption } from "../../common/helpers/getOption";
import PortalPageBox from "@portal/components/atoms/portalPageBox";

export const SustainabilityInfo = ({ isDefaultLanguage }: ISustainabilityProps) => {
  const { riskLevelRequest, setSustainability, setCalculationsSustainability } = useRobot();
  const [isExpanded, setIsExpanded] = useState(false);

  const texts = isDefaultLanguage ? RobotTextResources.primary : RobotTextResources.secondary;
  const options = [texts.PAGE_7_OPTIONS_1_A, texts.PAGE_7_OPTIONS_1_B];

  const OnSelectionClick = (selectedOption: number) => {
    if (selectedOption !== null) {
      setSustainability(selectedOption === 0);
      setCalculationsSustainability(selectedOption === 0);
    }
  };

  return (
    <div className="flex flex-col sm:flex-row sm:space-x-3">
      <PortalPageBox className="flex flex-col my-3 sm:w-[60%]">
        <Typography variant="Lead">{texts.PAGE_7_INFO_TEXT_1_HEADER}</Typography>
        <Typography variant="Body">{texts.PAGE_7_INFO_TEXT_1_A}</Typography>
        <div className="flex py-2 justify-center">
          <ChevronCircleButton isExpanded={isExpanded} setIsExpanded={setIsExpanded} />
        </div>
        {isExpanded && (
          <>
            <div className="flex mt-2">
              <Typography variant="Bold">{texts.PAGE_7_INFO_TEXT_1_B}</Typography>
            </div>
            <Typography variant="Body">{texts.PAGE_7_INFO_TEXT_1_C}</Typography>
            <Typography variant="Body">{texts.PAGE_7_INFO_TEXT_1_D}</Typography>
            <div className="flex mt-2">
              <Typography variant="Bold">{texts.PAGE_7_INFO_TEXT_1_E}</Typography>
            </div>
            <Typography variant="Body">{texts.PAGE_7_INFO_TEXT_1_F}</Typography>
            <Typography variant="Body">{texts.PAGE_7_INFO_TEXT_1_G}</Typography>
          </>
        )}
      </PortalPageBox>
      <div className="flex sm:w-[40%] w-full">
        <SelectionBoxComponent
          options={options}
          selectedOption={GetOption(riskLevelRequest.sustainability) ?? -1}
          onSelectionClick={OnSelectionClick}
        />
      </div>
    </div>
  );
};
